import React from 'react';
import { Section } from './ui/Section';
export function ContentOverview() {
  const tomos = [{
    icon: '📘',
    title: 'Estructura de Oro',
    desc: 'Framework 3-20-30-7 para cada clase'
  }, {
    icon: '📗',
    title: 'Matriz de Figuras',
    desc: '40 figuras + combos listos'
  }, {
    icon: '📙',
    title: 'Sensual y Moderna',
    desc: '25 secuencias listas para enseñar'
  }, {
    icon: '📕',
    title: 'Conexión',
    desc: 'Leading, following y los 7 tipos de señal'
  }, {
    icon: '📓',
    title: 'Musicalidad',
    desc: '5 niveles con ejercicios por nivel'
  }, {
    icon: '📔',
    title: 'Retención y Negocio',
    desc: 'Fideliza alumnos y escala tu negocio'
  }];
  return <Section variant="alt" data-id="element-107">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-108">
        📦 ¿Qué incluye?
      </h2>

      <div className="text-center text-sm text-brand-textMuted mb-8 md:hidden tracking-wide" data-id="element-109">
        ← Scroll to see full table →
      </div>

      <div className="overflow-x-auto" data-id="element-110">
        <table className="w-full min-w-[600px] border-collapse bg-gradient-card rounded-2xl overflow-hidden shadow-card border border-brand-border" data-id="element-111">
          <thead data-id="element-112">
            <tr className="bg-brand-card/50 border-b border-brand-borderGlow/20" data-id="element-113">
              <th className="text-left p-4 text-brand-title font-heading font-bold tracking-wide uppercase text-sm" data-id="element-114">
                Tomo
              </th>
              <th className="text-left p-4 text-brand-title font-heading font-bold tracking-wide uppercase text-sm" data-id="element-115">
                Lo que resuelve
              </th>
            </tr>
          </thead>
          <tbody data-id="element-116">
            {tomos.map((tomo, i) => <tr key={i} className="hover:bg-brand-card/30 transition-colors border-b border-brand-border/30 last:border-0" data-id="element-117">
                <td className="p-4" data-id="element-118">
                  <div className="flex items-center gap-3" data-id="element-119">
                    <span className="text-2xl" data-id="element-120">{tomo.icon}</span>
                    <span className="font-heading font-bold text-brand-subtitle" data-id="element-121">
                      {tomo.title}
                    </span>
                  </div>
                </td>
                <td className="p-4 text-brand-text font-body" data-id="element-122">{tomo.desc}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Section>;
}